import angular from 'angular'
import tansaComponent from './tansa.component'

export default angular
  .module('ellipsis.tansa', [])
  .component('tansa', tansaComponent)
